import { createContext } from "react";

export interface ChipsContextType {
	selectedValue: string;
	setSelectedValue: (value: string) => void;
}

export const ChipsContext = createContext<ChipsContextType | undefined>(
	undefined,
);
